/**
 * CRM Multi-Compagnia · Lista Subagenti
 */
import { useState } from "react";
import { Briefcase, Plus, Edit3, Trash2 } from "lucide-react";
import {
  api, useApi, DataTable, Spinner, ErrorBox, Btn, Modal, Field, TextInput,
  StatusBadge, toast
} from "@/components/crm-multi/shared";

export default function CrmMultiSubagentiPage() {
  const list = useApi(() => api.get("/subagents", {}));
  const [open, setOpen] = useState(false);
  const [form, setForm] = useState({ nome: "", cognome: "", email: "", telefono: "", codice_subagente: "", provvigione_pct: 10, attivo: true });

  const onSave = async (e) => {
    e.preventDefault();
    try { await api.post("/subagents", form); toast("Subagente creato", "success"); setOpen(false); list.refresh(); }
    catch (er) { toast(JSON.stringify(er?.response?.data?.detail || er.message), "error"); }
  };

  const onToggle = async (s) => {
    try { await api.patch(`/subagents/${s.id}?attivo=${!s.attivo}`, null); toast("Aggiornato", "success"); list.refresh(); }
    catch (er) { toast(er.message, "error"); }
  };

  const onDelete = async (id) => {
    if (!window.confirm("Eliminare il subagente?")) return;
    try { await api.del(`/subagents/${id}`); toast("Eliminato", "success"); list.refresh(); }
    catch (er) { toast(er.message, "error"); }
  };

  return (
    <div className="space-y-4" data-testid="cm-subagenti-page">
      <header className="flex justify-between items-center gap-3">
        <div>
          <h2 className="text-lg font-semibold flex items-center gap-2"><Briefcase className="w-5 h-5" /> Subagenti / Collaboratori</h2>
          <p className="text-sm text-zinc-500">{list.data?.total ?? 0} totali</p>
        </div>
        <Btn variant="primary" onClick={() => setOpen(true)} data-testid="cm-subagenti-new"><Plus className="w-4 h-4" /> Nuovo</Btn>
      </header>

      <ErrorBox error={list.error} />
      {list.loading ? <Spinner /> : (
        <DataTable
          testid="cm-subagenti-table"
          columns={[
            { key: "nominativo", label: "Nominativo", render: r => <p className="font-medium">{r.nome} {r.cognome}</p> },
            { key: "codice", label: "Codice", render: r => <code className="text-xs">{r.codice_subagente || "—"}</code> },
            { key: "email", label: "Email", render: r => <span className="text-xs">{r.email || "—"}</span> },
            { key: "telefono", label: "Telefono", render: r => <span className="text-xs">{r.telefono || "—"}</span> },
            { key: "provvigione", label: "% Provv.", render: r => <span className="font-mono text-xs">{r.provvigione_pct?.toFixed(1) || "—"}</span> },
            { key: "attivo", label: "Stato", render: r => <button onClick={() => onToggle(r)}><StatusBadge tipo="generic" valore={r.attivo ? "attivo" : "ex"} /></button> },
            { key: "az", label: "", render: r => <button onClick={() => onDelete(r.id)} className="text-rose-600 hover:text-rose-800"><Trash2 className="w-3.5 h-3.5" /></button> },
          ]}
          rows={list.data?.items || []}
          emptyTitle="Nessun subagente"
        />
      )}

      <Modal open={open} onClose={() => setOpen(false)} title="Nuovo subagente">
        <form onSubmit={onSave} className="space-y-3">
          <div className="grid grid-cols-2 gap-3">
            <Field label="Nome" required><TextInput required value={form.nome} onChange={(e) => setForm({ ...form, nome: e.target.value })} /></Field>
            <Field label="Cognome" required><TextInput required value={form.cognome} onChange={(e) => setForm({ ...form, cognome: e.target.value })} /></Field>
            <Field label="Email"><TextInput type="email" value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} /></Field>
            <Field label="Telefono"><TextInput value={form.telefono} onChange={(e) => setForm({ ...form, telefono: e.target.value })} /></Field>
            <Field label="Codice subagente"><TextInput value={form.codice_subagente} onChange={(e) => setForm({ ...form, codice_subagente: e.target.value })} /></Field>
            <Field label="Provvigione %"><TextInput type="number" step="0.1" value={form.provvigione_pct} onChange={(e) => setForm({ ...form, provvigione_pct: parseFloat(e.target.value || 0) })} /></Field>
          </div>
          <div className="flex justify-end gap-2 pt-2 border-t"><Btn variant="outline" type="button" onClick={() => setOpen(false)}>Annulla</Btn><Btn variant="primary" type="submit">Salva</Btn></div>
        </form>
      </Modal>
    </div>
  );
}
